export default {
  apiUrl(context, payload) {
    context.commit("setApiUrl", payload);
  },
  async config(context) {
    let url = context.state.apiUrl + "signup/config.php";
    const response = await fetch(url, {
      method: "POST",
      body: JSON.stringify({
        g2soft: 1,
      }),
    });

    const responseData = await response.json();
    // console.log(responseData);

    if (!response.ok || !responseData.success) {
      const error = new Error(
        responseData.message ||
          "Fout bij het ophalen van de algemene configuratie."
      );
      throw error;
    }

    const info = responseData.data;
    // console.log(info);
    context.commit("setAppConfig", {
      appVersion: process.env.VUE_APP_VERSION,
      config: info.config,
    });

    context.commit("setQuestions", info.questions);
    context.commit("setPlayerLevels", info.playerLevels);
    context.commit("setRankings", info.rankings);
    context.commit("setPlayerMoments", info.playerMoments);
    context.commit("setConfigHasBeenRead");

    const lsdata = {
      appVersion: process.env.VUE_APP_VERSION,
    };
    localStorage.setItem("subscribeConfig", JSON.stringify(lsdata));
  },
  async memberExists(context, payload) {
    let url = context.state.apiUrl + "signup/memberExists.php";
    const response = await fetch(url, {
      method: "POST",
      body: JSON.stringify({
        g2soft: 1,
        lastname: payload.lastName,
        firstname: payload.firstName,
        birthdate: payload.birthDate,
      }),
    });

    const responseData = await response.json();
    // console.log(responseData);

    if (!response.ok || !responseData.success) {
      const error = new Error(
        responseData.message ||
          "Fout bij het nazien of deze ledenfiche reeds bestaat."
      );
      throw error;
    }

    const memberExists = responseData.exists == 1 ? true : false;
    context.commit("setMemberExists", memberExists);
  },
  async register(context, payload) {
    let url = context.rootState.apiUrl + "signup/addMemberToWaitingList.php";

    payload = { g2soft: 1, data: payload };
    const response = await fetch(url, {
      method: "POST",
      body: JSON.stringify(payload),
    });

    const responseData = await response.json();
    // console.log(responseData);

    if (!response.ok) {
      context.commit("setRegistered", false);
      const error = new Error(
        responseData.message || "Fout bij het registreren van je aanmelding"
      );
      throw error;
    }

    context.commit("setRegistered", responseData.success);
  },
};
